import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sortable      from 'react-sortablejs';

import ProgressSpace from './progress-space';
import EazyBar       from './eazy-bar';
import Memo          from './memo';
// -------------------------------------------------------

const SPACE_SIZE = 370;

class ProgressContents extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.timer;
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      is_scroll : false,
    };
  }
  // -------------------------------------------------------
  
  componentDidMount() {
    try {
      let triggers = document.querySelectorAll('.progress-scroll');
      triggers.forEach(function(target) {
        target.addEventListener('wheel', function(){
          let scroll_h = target.scrollHeight - target.clientHeight;
          if( scroll_h > 0 ){
            this.setState({ is_scroll: true });
            clearTimeout(this.timer);
            this.timer = setTimeout( function(){ this.setState({ is_scroll: false }); }.bind(this), 50);
          }
          
        }.bind(this));
      }.bind(this));
    } catch(e) {console.log(e)}
    
    const scrollElement = document.querySelector("#progress-contents");
    scrollElement.addEventListener('wheel', (e) => {
      setTimeout( function(){ 
        if( this.state.is_scroll == true ) return;
        
        let elements = document.getElementsByClassName('contents-modal');
        if( elements.length > 0 ) return;
        
        if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
        e.preventDefault();
        scrollElement.scrollLeft += (e.deltaY * 1.5);
      }.bind(this), 5);
    });
    
  }
  // -------------------------------------------------------
  
  change(list, progress) {
    let base = this.props.base;
    
    // データ通信
    Utils.request.bind(this)('/api/project/workflow/drag', { project_id: base.project.id, list: list, progress: progress },
      function(res){
        base.event.refreshInfluencer.bind(this)(this.state.progress_change_id);
      }.bind(this)
    );
    
    // データ置き換え
    let workflow = Object.assign({}, base.workflow);
    
    list.map((insta_user_id) => {
      let temp = {};
      for( let i in workflow.items ){
        workflow.items[i] = workflow.items[i].filter((d, key) => {
          if( d.insta_user_id == insta_user_id ){
            temp = d;
          } else {
            d.order_no = key;
            return d;
          }
        });
      }
      
      if( Object.keys(temp).length > 0 ){
        if( workflow.items[progress] == undefined ) workflow.items[progress] = [];
        if( temp.progress != progress ){
          temp.progress = progress;
          this.setState({ progress_change_id: temp.insta_user_id });
        }
        workflow.items[progress].push(temp);
        workflow.influencers[insta_user_id].progress = progress;
      }
    });
    
    workflow.items_base = Object.assign({}, workflow.items);
    base.event.updateData.bind(this)('workflow', workflow);
  }
  // -------------------------------------------------------
  
  changeSpace(list) {
    let base = this.props.base;
    
    // データ通信
    Utils.request.bind(this)('/api/project/workflow/space_drag', { project_id: base.project.id, list: list },
      function(res){
        //base.event.refreshInfluencer.bind(this)(this.state.progress_change_id);
        base.event.updateData.bind(this)('workflow',res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    // グループ設定
    let workflow = base.workflow.list.concat();
    
    // ストックにデータが存在しない場合は非表示
    if( base.workflow.items.stock == undefined ){
      workflow = workflow.filter((d) => { if( d.id != 'stock' ) return d; });
    }
    
    return (
      <div id="progress-contents" className="progress-contents">
        <Sortable options={{ group: 'space', animation: 150, handle: '.handle' }} tag="div" className="progress-list" style={{ width: (workflow.length * SPACE_SIZE) }} onChange={this.changeSpace.bind(this)}>
          { workflow.map((d, key) => {
            return <ProgressSpace key={key} progress={d} base={base} list={base.workflow.items[d.id]} change_ev={(items) => { this.change.bind(this)(items, d.id) }} />;
          })}
        </Sortable>
        
        <EazyBar speed_type="left" />
        <Memo base={base} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressContents;